import { Notification } from 'element-ui'
import NotifyContent from './NotifyContent.vue'
import Vue from 'vue'
import { getCashOutMonitorNotifyEnabled } from './const'
/**
 * 连续等额提现异常通知
 */
export function onMerchantCashOutAlert(msg) {
  const notifyEnabled = getCashOutMonitorNotifyEnabled()
  if (!notifyEnabled) {
    return
  }

  // must use $rootApp
  const h = Vue.prototype.$rootApp.$createElement
  let notify = null
  notify = Notification({
    customClass: 'merchant-cash-out-alert',
    message: h(NotifyContent, {
      props: {
        msg
      },
      on: {
        close: () => {
          notify?.close()
        }
      }
    }),
    duration: 0
  })
}
